import React from 'react';

const ChevronDown: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    {...props}
  >
    <path
      d="M1 1L5.41074 5.41074C5.68852 5.68852 5.82741 5.82741 6 5.82741C6.17259 5.82741 6.31148 5.68852 6.58926 5.41074L11 1"
      stroke="#002564"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronDown;
